






















// @ is an alias to /src
import TitleBar from '@/modules/core/components/TitleBar.vue';
import UserComponent from '../components/User.vue';
import CardComponent from '@/modules/core/components/CardComponent.vue';
import { userApi } from '../user.api';
import { Component, Vue } from 'vue-property-decorator';
import { User } from '../user';

@Component({
  components: {
    TitleBar,
    User: UserComponent,
    CardComponent,
  },
})
export default class UserView extends Vue {
  public user: User | null = null;
  public get titleStack(): string[] {
    if (!this.user) {
      return [];
    }

    return ['Admin', this.user.roleLabel, this.user.fullname];
  }

  public get userId(): string {
    return this.$route.params.id;
  }

  public async getUser(): Promise<void> {
    this.user = await userApi.get(this.userId);
  }

  public mounted(): void {
    this.getUser();
  }
}
